export function derivativeThumbsForJob(job) {
  return [];
}
